export default __webpack_public_path__ + "static/media/Shop-9.7ebe71b3.webp";